import React from 'react';
import { translate, getBuyerStaticContentUrl } from 'utils/common';
import noImage from 'assets/images/no-image.png';
export const NoData = (props) => <div className="no-data"><i className="fas fa-exclamation-triangle"></i><label>{translate(props.label) || translate('nodatafound')}</label></div>

export const MsgPanel = (props) => <div className="msg-panel">
    {/* <span className="icon rounded-circle"><i className={"fas " + (props.type == 'success' ? "fa-check-circle" : "fa-exclamation-circle")}></i></span> */}
    {/* <h3>{props.type == 'success' ? "Success" : "Failed"}</h3> */}
    {props.title && <h3>{props.title}</h3>}
    <div className="msg">{translate(props.msg)}</div>
    <p className="mb-2"><button type="button"
        className={"btn btn-primary"}
        // className={"btn btn-block " + (props.type == 'success' ? "btn-success " : "btn-danger ")}
        onClick={props.onClick} >{translate('ok')}</button></p>
</div>

export const ActiveInactiveButton = (props) => {
    const activeClass = props.activeClass ? props.activeClass : 'btn-primary';
    const inactiveClass = props.inactiveClass ? props.inactiveClass : 'btn-tertiary';
    return (
        <button
            className={'btn ' + (props.active ? activeClass : inactiveClass) + (props.customClass ? ' ' + props.customClass : '')}
            onClick={(props.enableDeactiveClick || props.active) ? props.onClick : () => { }}
        >
            {translate(props.label)}
        </button>
    );
}

export const ProductFormatterMini = (props) => {
    const image = props.computeImageUrl ? getBuyerStaticContentUrl(props.image) : props.image;
    return (
        <div className="d-flex">
            <div className="flex-2 d-flex align-items-center">
                <img className="mr-3" src={image} style={{ 'maxWidth': '151px', 'maxHeight': '62px' }} />
                <p className="mb-0">{props.skuName} {props.rank ? '#' + props.rank : ''}</p>
            </div>
        </div>
    )
}

export const ProductFormatter = (props) => <React.Fragment>
    <div className="d-flex align-items-start prod-desc-wrap flex-column" >
        <div className="d-flex">
            {!props.noImage &&
                // <div className="product-list-image-wrap d-flex justify-content-start flex-wrap">
                <div className="product-list-image-wrap d-flex justify-content-center">
                    <img className="product-list-image img-fluid align-self-center" src={props.image ? props.image : noImage} />
                </div>
            }
            {/* <div className="ml-3 d-flex justify-content-center align-items-start flex-column">
                {
                    props.onClick &&
                    <h5 className="mb-0 no-bold">
                        <a onClick={props.onClick} className="btn btn-link lesspad color-primary">
                            {translate('groupSearchSelectItems.skuNumber')}: {props.skuNumber}
                        </a>
                    </h5>
                }
                {
                    !props.onClick &&
                    <h5 className="mb-0 no-bold">{translate('groupSearchSelectItems.skuNumber')}: {props.skuNumber}</h5>
                }
                <h5 className="mt-3 mb-3 no-bold">{translate('groupSearchSelectItems.partNumber')}: {props.mpn}</h5>
            </div> */}
        </div>
        {/* <h5 className="mt-3 mb-0 no-bold base-color-light">{props.skuName}</h5> */}
    </div>
</React.Fragment> 

export const ProgressBar = ({ percentage, className = '', id }) => {
    const width = parseFloat(percentage).toFixed(2) + '%';
    return (
        <div className="progress mt-3" id={id}>
            <div className={'progress-bar bg-success ' + className} style={{ width: width }} >
            </div>
            <div className="progress-value">{percentage}%</div>
        </div>
    );
}
